import React from 'react';
import { useField } from 'formik';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';

export const KeyboardKeyField: React.FC = () => {
  const [field, meta] = useField<string>({ name: 'keyboardKey' });

  return (
    <FormField
      label={<Label>Key</Label>}
      required
      control={<Input {...field} autoComplete={'off'} />}
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
